import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { WorkspacePendingInvite } from "@common/dto/workspace/workspace-pending-invite.dto";
import { Avatar } from "@design-system/Avatar/Avatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { FC } from "react";

interface PendingInviteIconProps {
    invite: WorkspacePendingInvite;
}

/** An invited person's avatar, with the invite's email and role in a tooltip. */
export const PendingInviteIcon: FC<PendingInviteIconProps> = ({ invite }) => (
    <AvatarTooltip
        title="Pending invite"
        content={
            <>
                {invite.email}
                <br />
                {WORKSPACE_ROLES_LABELS[invite.role]}
            </>
        }
    >
        <Avatar name={invite.email} variant="outline" tone="neutral" />
    </AvatarTooltip>
);
